import { render, staticRenderFns } from "./specifications.vue?vue&type=template&id=2044d268&"
import script from "./specifications.vue?vue&type=script&lang=js&"
export * from "./specifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports